import { render, staticRenderFns } from "./FormTransport.vue?vue&type=template&id=2ab14920&"
import script from "./FormTransport.vue?vue&type=script&lang=js&"
export * from "./FormTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab14920')) {
      api.createRecord('2ab14920', component.options)
    } else {
      api.reload('2ab14920', component.options)
    }
    module.hot.accept("./FormTransport.vue?vue&type=template&id=2ab14920&", function () {
      api.rerender('2ab14920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/components/FormTransport.vue"
export default component.exports